type MenuItem = {
  path?: string;
  children?: MenuItem[];
  [key: string]: unknown;
};

export const MENU_PERMISSION_BY_PATH: Record<string, string> = {
  '/organization/branches': 'branches:read',
  '/organization/merchants': 'merchants:read',
  '/organization/products': 'products:read',
  '/organization/banks': 'banks:read',
  '/organization/terminals': 'terminals:read',
  '/organization/transactions': 'processorTransactions:read',
  '/organization/batches': 'processorBatches:read',
  '/report/revenue-sharing': 'revenueSharing:read',
  '/loyalty/customers': 'loyalty:read',
  '/loyalty/rewards': 'loyalty:read',
  '/loyalty/history': 'loyalty:read',
  '/loyalty/policy': 'loyalty:read',
  '/loyalty/cards': 'loyalty:card:rebind',
  '/product-library': 'productLibrary:read',
  '/product-library/einvoices': 'einvoices:read',
  '/admin/users': 'admin/users:read',
  '/admin/roles': 'roles:read',
  '/admin/partnerCredentials': 'partnerCredentials:read',
};

export function hasPermission(
  permissions: readonly string[] | undefined,
  requiredPermission: string,
) {
  const grants = new Set(permissions ?? []);
  if (grants.has('*:*') || grants.has(requiredPermission)) return true;

  const [scope] = requiredPermission.split(':', 1);
  return grants.has(`${scope}:*`);
}

export function filterMenuDataByPermissions<T extends MenuItem>(
  menuData: T[],
  permissions: readonly string[] | undefined,
): T[] {
  return menuData.flatMap((item) => {
    const hasChildren =
      Array.isArray(item.children) && item.children.length > 0;
    const children = hasChildren
      ? filterMenuDataByPermissions(item.children as T[], permissions)
      : undefined;

    // A group is visible only when at least one of its menu children is visible.
    if (hasChildren) {
      return children?.length ? [{ ...item, children } as T] : [];
    }

    const requiredPermission = item.path
      ? MENU_PERMISSION_BY_PATH[item.path.replace('/*', '')]
      : undefined;
    return !requiredPermission || hasPermission(permissions, requiredPermission)
      ? [item]
      : [];
  });
}
